<IDatePicker
  class="z-60"
  [dateFormat]="dateFormat()"
  [minDate]="twoYearsAgo"
  [selectedDateRange]="selectedDateRange()"
  (selectedDateRangeChange)="selectDateRange($event)"
  *transloco="let t"
>
  <span class="text-subtle-foreground">|</span>
  <span>{{ t("date-range-selection.compare_to") }} :</span>
  <app-period-comparison />
</IDatePicker>
